import React from 'react'
import { sanitizeHtml } from '@/lib/sanitize-html'

interface Props {
  htmlContent: string
}

const HtmlRenderer: React.FC<Props> = ({ htmlContent }) => {
  return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlContent) }} />
}

export default HtmlRenderer
